export default __webpack_public_path__ + "static/inline-usage-example-6fe5b45afca2c4d19c531113de31dc68.png";